import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const IconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StatusBadge = styled.div<{ $backgroundColor?: string }>`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;

  bottom: -0.2rem;
  right: -0.2rem;

  width: 1.2rem;
  height: 1.2rem;

  border-radius: 50%;
  background-color: ${({ theme, $backgroundColor }) =>
    $backgroundColor ?? theme.palette.success.main};
  border: 1px solid ${({ theme }) => theme.palette.background.default};

  color: ${({ theme }) => theme.palette.common.white};
  font-size: 0.8rem;
`;

export const GoalInfoContainer = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  min-width: 0;
  width: 100%;
`;

export const ParentLabel = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};

  max-width: 100%;

  overflow: hidden;

  color: ${({ theme }) => theme.palette.text.secondary};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const GoalName = styled.span<{
  $isCompleted?: boolean;
  $isArchived?: boolean;
}>`
  max-width: 100%;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ $isArchived, theme }) =>
    $isArchived &&
    css`
      color: ${theme.palette.text.secondary};
    `}

  ${({ $isCompleted, $isArchived }) =>
    $isCompleted &&
    !$isArchived &&
    css`
      text-decoration: line-through;
      opacity: 0.6;
    `}
`;
